import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatPaginator, MatDialog, MatSort } from '@angular/material';
import { ItemGrid } from '../../models/item';
import { modalComponent } from '../../utils/modal/modal.component';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { generalService } from '../../services/general.service';
import { DataService } from '../../utils/data.service';
import { Vehiculo } from '../../models/vehiculo';
import { DataSourceGrid } from '../../utils/data-source-grid.component';
import { ActivatedRoute } from '@angular/router';


@Component({
    selector: 'my-vehicle-consultar',
    styleUrls: [], 
    templateUrl: 'vehiculos-consultar.component.html',
    providers: [generalService]
})
export class VehiculoConsultarComponent implements OnInit{

    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    dataSource: DataSourceGrid | null;
    displayedColumns = ['acciones', 'NOMBRE','TIPO_PERMISO','NUMERO_PERMISO_SCT','CONFIGURACION_VEHICULAR','PLACA_VM','MODELO','POLIZA_RC','ASEGURADORA_RC','PESO_BRUTO'];
    public datosVehiculo: Array<ItemGrid>;
    public vehiculo :Vehiculo;
    public dataVehiculo:any;

    // Modal messages
    private readonly CONFIRM_DELETE_MSG = '¿Está seguro que desea eliminar el vehículo?';

    constructor(private _generalService: generalService, 
                public dataService: DataService, 
                public dialog: MatDialog,
                public _activated : ActivatedRoute) {
                  this.vehiculo = new Vehiculo();
                  this.datosVehiculo = new Array();
    }
    
    ngOnInit() {
      this.consultarVehiculos();
    }

    consultarVehiculos(){
        let vehiculo = new Vehiculo();
        let metodo = 'Vehiculo/consultVehicles';
       
        const params = { 
          loacs: sessionStorage.getItem('acslo')  
        };

        this._generalService.metodoCallParams(params, metodo).subscribe(
          result => {
            this.datosVehiculo = JSON.parse(result);
        
            this.dataSource = new DataSourceGrid(this.datosVehiculo, this.paginator, this.sort);
            
            if(this.datosVehiculo.length <= 0)
              { $(".mat-row").remove(".mat-row"); }
            
            },
          error => {  console.log(<any>error);  }
        );
    }

    confirmDeleteVehicle(vehiculo: ItemGrid) {
        this.dataService.modal = 'confirm';
        this.dataService.mensaje = this.CONFIRM_DELETE_MSG;
      
        const dialogModal = this.dialog.open(modalComponent, {disableClose: true});
        this.dataService.dialogRef = dialogModal;

        this.dataVehiculo=vehiculo;
      
        dialogModal.afterClosed().subscribe(result => {
          if (this.dataService.guardado) {
            this.deleterow(this.dataVehiculo);
          }
        });
    }
      
    deleterow(vehiculo: any) {
        const params = { 
          loacs: sessionStorage.getItem('acslo'),
          idvehiculo:vehiculo.VEHICLE_ID
        };
        this._generalService.metodoCallParams(params, `Vehiculo/deleteVehiculo`)
        .subscribe(ok => {
            
            this.consultarVehiculos();
            
            setTimeout(() => {
                this._generalService.toastCall("El registro se dio de baja exitosamente");
              }, 500); 

        }, error => {
          // Custom error handler
        }); 
    }

    searchFilter(searchTerm: string) {
      if(this.datosVehiculo.length <= 0) {
        this.dataSource = undefined;
      } else {
        let filtroVehiculos = this.datosVehiculo;
        if(searchTerm != "") {
          filtroVehiculos = this.datosVehiculo.filter((obj: any) => {            
            if (obj.NOMBRE.toLowerCase().indexOf(searchTerm.toLowerCase()) != -1 
            //|| obj.POLIZA_RC && obj.POLIZA_RC.toLowerCase().indexOf(searchTerm.toLowerCase()) != -1 
            )
                return true;
            else
                return false;
          });
        }
        this.dataSource = new DataSourceGrid(filtroVehiculos, this.paginator, this.sort);
      }
    }
      
}


// WEBPACK FOOTER //
// ./src/app/vehiculo/consultar-eliminar/vehiculos-consultar.component.ts